import React, { useEffect, useState, CSSProperties, useRef } from 'react';
import '../App.css';
import './Widgets.css'
import axios from 'axios';
import { TextField, Button, Stack } from "@mui/material"
import { ClipLoader, HashLoader, RingLoader } from "react-spinners";
import NavBar from '../Widgets/NavBar';
import Footer from '../Widgets/Footer';

export default function Widgets() {

    useEffect(() => {
        document.title = "Widgets";
    }, []);

    return (
        <div className="page-wrapper">
            <header className="py-5">
                <div className="container">
                    <div className="row">
                        <NavBar selected="widgets-page"></NavBar>
                    </div>
                </div>
            </header>

            {/* Primeira Linha */}
            <WeatherSearch></WeatherSearch>

            {/* Segunda Linha */}
            <RandomNumberGenerator></RandomNumberGenerator>

            {/* Minesweeper */}
            <Minesweeper></Minesweeper>

            <Footer></Footer>
        </div>
    );

    function RandomQuote() {
        const [Quote, setQuote] = useState([]);

        useEffect(() => {
            loadQuote();
        }, []);

        function loadQuote() {
            axios.get('https://go-quote.azurewebsites.net/ramdom-quote')
                .then(res => {
                    if (res.status === 200) {
                        let quote = String(res.data).split(":");
                        setQuote(quote);
                    } else {
                        alert("Error fetching weather data!");
                    }
                })
                .catch(error => {
                    alert("Error: " + error);
                });
        }

        return Quote.map((part, index) => {
            if (index === 0 && part.includes("Quote")) {
                return
            }
            else if (index === 1 && part.includes("Author")) {
                part = part.slice(0, part.length - 7)
                return <p>{part}</p>
            }
            else if (index === 2) {
                part = part.slice(0, part.length - 5)
                return <p>Author: {part}</p>
            }
        })
    }

    function WeatherSearch() {
        const APIKEY = '052a76c8649242f8527d0813d3ad097e';
        const [city, setCity] = useState()
        const [country, setCountry] = useState()
        const [weatherData, setWeatherData] = useState([])

        const [isLoading, setIsLoading] = useState(false)
        const [hasError, setHasError] = useState(false)
        const [hasSuccess, setHasSuccess] = useState(false)
        const [error, setError] = useState()

        const override: CSSProperties = {
            display: "block",
            margin: "0 auto",
        };

        function loadWeather() {
            setIsLoading(true)
            setHasError(false)
            setError()
            setHasSuccess(false)

            if (!city || !country) {
                setIsLoading(false)
                setHasError(true)
                setError("Please define both the city and country, then try again.")
                return;
            }
            const url = `https://api.openweathermap.org/data/2.5/weather?q=${city},${country}&APPID=${APIKEY}&units=metric`;
            axios.get(url)
                .then(res => {
                    if (res.status === 200) {
                        setHasSuccess(true)
                        setWeatherData(res.data);
                    } else {
                        setHasError(true)
                        setError("Error fetching weather data, try again.")
                    }
                })
                .catch(error => {
                    setHasError(true)
                    setError("Error while trying to reach the API. Please try again later. -> " + error)
                });
            setIsLoading(false)
        };

        return (
            <section>
                <div className='container py-5'>
                    <div className='row'>
                        <div className='col-md-12 box border p-4' style={{ borderRadius: "20px" }}>
                            <div className='row'>
                                <div className='col-md-12 mb-2'>
                                    <h4 style={{ color: "#ff784e" }}>Search Weather</h4>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-6'>
                                    <Stack className='my-3'>
                                        <TextField
                                            label="City"
                                            type="text"
                                            name="city"
                                            InputProps={{
                                                sx: {
                                                    color: "black",
                                                    backgroundColor: "white",
                                                },
                                            }}
                                            onChange={(value) => setCity(value.target.value)}
                                            value={city}
                                        />

                                        <TextField
                                            label="Country"
                                            type="text"
                                            name="country"
                                            className="my-3"
                                            InputProps={{
                                                sx: {
                                                    color: "black",
                                                    backgroundColor: "white",
                                                },
                                            }}
                                            onChange={(value) => setCountry(value.target.value)}
                                            value={country}
                                        />

                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={loadWeather}
                                        >
                                            Search
                                        </Button>

                                        <Button
                                            variant="contained"
                                            color="error"
                                            onClick={() => { setHasSuccess(false); setWeatherData(null); setHasError(false); setCity(""); setCountry("") }}
                                            className="mt-3"
                                        >
                                            Clear
                                        </Button>
                                    </Stack>

                                </div>
                                <div className='col-md-6 d-flex'>
                                    <div className='mt-2'>
                                        {!isLoading && !hasError && !hasSuccess && (
                                            <div style={{ margin: "0 auto" }}>
                                                Waiting for an input :)
                                            </div>
                                        )}

                                        {isLoading && (
                                            <ClipLoader
                                                color={"#ffffff"}
                                                loading={isLoading}
                                                cssOverride={override}
                                                size={120}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                            />
                                        )}

                                        {hasError && (
                                            <div style={{ margin: "0 auto" }}>
                                                {error}
                                            </div>
                                        )}

                                        {hasSuccess && (
                                            <>
                                                {weatherData && weatherData.sys && weatherData.main && weatherData.wind && weatherData.weather && weatherData.dt && (
                                                    <div>
                                                        <p><strong>City:</strong> {weatherData.name}</p>
                                                        <p><strong>Country:</strong> {weatherData.sys.country}</p>
                                                        <p><strong>Temperature:</strong> {weatherData.main.temp} °C</p>
                                                        <p><strong>Wind Speed:</strong> {weatherData.wind.speed} m/s</p>
                                                        <p><strong>Description:</strong> {weatherData.weather[0].description}</p>
                                                        <p><strong>Current Time:</strong> {Date(weatherData.dt)}</p>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    function RandomNumberGenerator() {
        const [randomNumber, setRandomNumber] = useState(null);
        const [randomString, setRandomString] = useState('');
        const [coinResult, setCoinResult] = useState('');

        const [headsCounter, setHeadsCounter] = useState(0);
        const [tailsCounter, setTailsCounter] = useState(0);
        const [totalCounter, setTotalCounter] = useState(0);

        const [min, setMin] = useState('');
        const [max, setMax] = useState('');

        const generateRandomNumber = () => {
            if (min !== '' && max !== '') {
                const num = Math.floor(Math.random() * (parseInt(max) - parseInt(min) + 1)) + parseInt(min);
                setRandomNumber(num);
            }
        };

        const [stringLength, setStringLength] = useState('');

        const generateRandomString = () => {
            if (stringLength !== '' && stringLength <= 32 && stringLength > 0) {
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789[]!@#$%^&*()_+-=}{,.<>/;:"?';
                let result = '';
                for (let i = 0; i < parseInt(stringLength); i++) {
                    result += characters.charAt(Math.floor(Math.random() * characters.length));
                }
                setRandomString(result);
            }
            if (stringLength > 32 || stringLength < 1) {
                alert("The length has to be between 1 and 32")
            }
        };

        const flipCoin = () => {
            const result = Math.random() < 0.5 ? 'Heads' : 'Tails';
            result == 'Heads' ? setHeadsCounter(prev => prev + 1) : setTailsCounter(prev => prev + 1);
            setTotalCounter(prev => prev + 1);
            setCoinResult(result);
        };

        return (
            <section>
                <div className='container pb-5'>
                    <div className='row'>
                        <div className='col-md-12 box border p-4' style={{ borderRadius: "20px" }}>
                            <div className='row'>
                                <div className='col-md-12 mb-2 justify-content-between align-items-center d-flex'>
                                    <h4 style={{ color: "#ff784e" }}>Coin Flip</h4>
                                    <h4 style={{ color: "#ff784e" }}>Random Number</h4>
                                    <h4 style={{ color: "#ff784e" }}>Random String</h4>
                                </div>
                            </div>

                            <div className='row my-3'>
                                <div className='col-md-4'>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <Button
                                                variant="contained"
                                                color="success"
                                                fullWidth
                                                onClick={flipCoin}
                                            >
                                                Coin Flip
                                            </Button>
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col-md-12 d-flex'>
                                            <strong>Result:</strong>
                                            {coinResult && (
                                                <div style={{ margin: '0 auto' }}>
                                                    {coinResult}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className='row mt-3'>
                                        <div className='col-md-12'>
                                            <p>History:</p>
                                            <div className='row'>
                                                <div className='col-md-6 d-flex'>
                                                    <div style={{ margin: '0 auto' }}>
                                                        <p>Heads:</p>
                                                        {headsCounter} ({totalCounter && Math.round((headsCounter / totalCounter) * 100 * 100) / 100}%)

                                                    </div>
                                                </div>
                                                <div className='col-md-6 d-flex'>
                                                    <div style={{ margin: '0 auto' }}>
                                                        <p>Tails:</p>
                                                        {tailsCounter} ({totalCounter && Math.round((tailsCounter / totalCounter) * 100 * 100) / 100}%)
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <Stack>
                                        <div className='row mb-3'>
                                            <div className='col-md-6'>
                                                <TextField
                                                    label="Minimum"
                                                    type="number"
                                                    name="minNumber"
                                                    fullWidth
                                                    InputProps={{
                                                        sx: {
                                                            color: "black",
                                                            backgroundColor: "white",
                                                        },
                                                    }}
                                                    onChange={(value) => setMin(value.target.value)}
                                                />
                                            </div>
                                            <div className='col-md-6'>
                                                <TextField
                                                    label="Maximum"
                                                    type="number"
                                                    name="maxNumber"
                                                    fullWidth
                                                    InputProps={{
                                                        sx: {
                                                            color: "black",
                                                            backgroundColor: "white",
                                                        },
                                                    }}
                                                    onChange={(value) => setMax(value.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <Button
                                            variant="contained"
                                            color="success"
                                            onClick={generateRandomNumber}
                                            className="mb-3"
                                        >
                                            Generate
                                        </Button>

                                        <div className='d-flex'>
                                            <strong>Result:&nbsp;</strong>{randomNumber}
                                        </div>
                                    </Stack>
                                </div>
                                <div className='col-md-4'>
                                    <Stack>
                                        <TextField
                                            label="String Length"
                                            type="number"
                                            name="strLength"
                                            className='mb-3'
                                            fullWidth
                                            InputProps={{
                                                sx: {
                                                    color: "black",
                                                    backgroundColor: "white",
                                                },
                                            }}
                                            onChange={(value) => setStringLength(value.target.value)}
                                        />

                                        <Button
                                            variant="contained"
                                            color="success"
                                            onClick={generateRandomString}
                                            className="mb-3"
                                        >
                                            Generate
                                        </Button>

                                        <div className='d-flex'>
                                            <strong>Result:&nbsp;</strong>{randomString}
                                        </div>
                                    </Stack>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    function Minesweeper() {
        const heightOptions = [10, 20, 30, 40, 50];
        const widthOptions = [10, 20, 30, 40, 50];
        const mineOptions = [10, 15, 20, 25]; // Different mine count options

        const [board, setBoard] = useState([]);
        const [totalHeight, setTotalHeight] = useState(heightOptions[0]); // Default to first option
        const [totalWidth, setTotalWidth] = useState(widthOptions[0]); // Default to first option
        const [rCell, setRCell] = useState(totalHeight * totalHeight);
        const [gameStatus, setGameStatus] = useState("playing");
        const [totalMines, setTotalMines] = useState(mineOptions[0]); // Default to first option
        const [totalCountMines, setTotalCountMines] = useState(mineOptions[0])

        const mineRef = useRef({});

        useEffect(() => {
            if (totalHeight) {
                reset();
            }
        }, [totalHeight])

        // Initialize/reset the game
        const reset = () => {
            const newBoard = [];
            for (let row = 0; row < totalHeight; row++) {
                const newRow = [];
                for (let col = 0; col < totalHeight; col++) {
                    newRow.push({
                        r: false,  // revealed
                        x: false,  // marked
                        m: false,  // mine
                        a: 0       // adjacent mines
                    });
                }
                newBoard.push(newRow);
            }

            // Place mines
            let minesToLay = totalCountMines;
            while (minesToLay > 0) {
                const row = Math.floor(Math.random() * totalHeight);
                const col = Math.floor(Math.random() * totalHeight);
                if (!newBoard[row][col].m) {
                    newBoard[row][col].m = true;
                    minesToLay--;
                }
            }

            // Calculate adjacent mines
            const directions = [-1, 0, 1];
            for (let row = 0; row < totalHeight; row++) {
                for (let col = 0; col < totalHeight; col++) {
                    if (newBoard[row][col].m) continue;
                    let count = 0;
                    for (let dr of directions) {
                        for (let dc of directions) {
                            if (dr === 0 && dc === 0) continue;
                            const nr = row + dr;
                            const nc = col + dc;
                            if (nr >= 0 && nr < totalHeight && nc >= 0 && nc < totalHeight) {
                                if (newBoard[nr][nc].m) count++;
                            }
                        }
                    }
                    newBoard[row][col].a = count;
                }
            }

            setBoard(newBoard);
            setRCell(totalHeight * totalHeight - totalCountMines); // Only non-mine cells count toward victory
            setGameStatus("playing");
        };

        // Mark cell (right click)
        mineRef.current.mark = (row, col) => {
            if (gameStatus !== "playing") return;
            if (board[row][col].r) return;

            setBoard(prevBoard => {
                const newBoard = [...prevBoard];
                newBoard[row] = [...newBoard[row]];
                newBoard[row][col] = {
                    ...newBoard[row][col],
                    x: !newBoard[row][col].x
                };
                return newBoard;
            });
        };

        // Open cell (left click)
        mineRef.current.open = (row, col) => {
            if (gameStatus !== "playing") return;
            if (board[row][col].x) return; // Don't open marked cells

            const updatedBoard = board.map(r => r.map(c => ({ ...c })));
            let updatedRCell = rCell;
            let gameLost = false;
            let gameWon = false;
            const toReveal = [];
            const toCheck = [[row, col]];
            const visited = new Set();

            const key = (r, c) => `${r},${c}`;

            if (updatedBoard[row][col].m) {
                updatedBoard[row][col].boom = true;
                gameLost = true;
            } else {
                while (toCheck.length > 0) {
                    const [r, c] = toCheck.shift();
                    const cell = updatedBoard?.[r]?.[c];

                    if (!cell || cell.m || cell.r || cell.x) continue;

                    const cellKey = key(r, c);
                    if (visited.has(cellKey)) continue;
                    visited.add(cellKey);

                    toReveal.push([r, c]);

                    if (cell.a == 0) {
                        for (let dr of [-1, 0, 1]) {
                            for (let dc of [-1, 0, 1]) {
                                if (dr == 0 && dc == 0) continue;
                                const nr = r + dr;
                                const nc = c + dc;
                                if (
                                    nr >= 0 && nr < totalHeight &&
                                    nc >= 0 && nc < totalHeight &&
                                    !visited.has(key(nr, nc))
                                ) {
                                    toCheck.push([nr, nc]);
                                }
                            }
                        }
                    }
                }

                for (const [r, c] of toReveal) {
                    const cell = updatedBoard[r][c];
                    if (!cell.r) {
                        cell.r = true;
                        updatedRCell--;
                    }
                }

                if (updatedRCell === 0) {
                    gameWon = true;
                }
            }

            setBoard(updatedBoard);
            setRCell(updatedRCell);
            setGameStatus(gameLost ? "lost" : gameWon ? "won" : "playing");

            setTimeout(() => {
                if (gameLost) {
                    alert("Oops. You lost.");
                    reset();
                } else if (gameWon) {
                    alert("YOU WIN!");
                    reset();
                }
            }, 50);
        };

        // Run on mount and when totalMines changes
        useEffect(() => {
            reset();
        }, [totalCountMines]);

        const handleCellClick = (row, col) => {
            mineRef.current.open(row, col);
        };

        const handleContextMenu = (e, row, col) => {
            e.preventDefault();
            mineRef.current.mark(row, col);
        };

        const handleMineCountChange = (e) => {
            let mineCount = (totalHeight * totalHeight) * (e.target.value / 100)
            setTotalMines(e.target.value)
            setTotalCountMines(parseInt(mineCount));
        };

        return (
            <section>
                <div className='container pb-5'>
                    <div className='row'>
                        <div className='col-md-12 box border p-4' style={{ borderRadius: "20px" }}>
                            <div className='row'>
                                <div className='col-md-12 mb-2 d-flex justify-content-between align-items-center'>
                                    <h4 style={{ color: "#ff784e" }}>Minesweeper</h4>
                                    <div>
                                        <label htmlFor="mine-count" className="me-2">Height:</label>
                                        <select
                                            id="height-width"
                                            value={totalHeight}
                                            onChange={(value) => { setTotalHeight(parseInt(value.target.value)) }}
                                            disabled={gameStatus === "playing" && rCell < totalHeight * totalHeight - totalCountMines}
                                        >
                                            {heightOptions.map(count => (
                                                <option key={count} value={count}>{count}</option>
                                            ))}
                                        </select>
                                        <label htmlFor="mine-count" className="me-2">&nbsp;&nbsp;&nbsp;&nbsp;Mines:</label>
                                        <select
                                            id="mine-count"
                                            value={totalMines}
                                            onChange={handleMineCountChange}
                                            disabled={gameStatus === "playing" && rCell < totalHeight * totalHeight - totalCountMines}
                                        >
                                            <option key={10} value={10}>10% (Beginner)</option>
                                            <option key={15} value={15}>15% (Intermediate)</option>
                                            <option key={20} value={20}>20% (Hard)</option>
                                            <option key={25} value={25}>25% (Very Hard)</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div
                                            id='mine-wrap'
                                            style={{
                                                display: 'grid',
                                                gridTemplateColumns: `repeat(${totalHeight}, 1fr)`,
                                                gap: '1px',
                                                backgroundColor: '#ddd'
                                            }}
                                        >
                                            {board.length > 0 ? (
                                                board.map((row, rowIndex) => (
                                                    row.map((cell, colIndex) => (
                                                        <div
                                                            key={`${rowIndex}-${colIndex}`}
                                                            className={`cell 
                                                            ${cell.x ? 'mark' : ''} 
                                                            ${cell.r ? 'reveal' : ''}
                                                            ${cell.boom ? 'boom' : ''}`}
                                                            onClick={() => handleCellClick(rowIndex, colIndex)}
                                                            onContextMenu={(e) => handleContextMenu(e, rowIndex, colIndex)}
                                                            style={{
                                                                aspectRatio: '1/1',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                backgroundColor: cell.r || cell.boom ? '#f7f7f7' : '#ccc',
                                                                border: cell.r || cell.boom ? '1px solid #aaa' : '2px outset #eee',
                                                                cursor: 'pointer',
                                                                userSelect: 'none',
                                                                fontSize: '1em', // Add this to control emoji size
                                                                color: 'black'
                                                            }}
                                                        >
                                                            {cell.r && !cell.m && cell.a > 0 ? cell.a : ''}
                                                            {cell.boom && <span style={{ fontSize: '1.2em' }}>💣</span>}
                                                            {cell.x && !cell.r && <span style={{ fontSize: '1.2em' }}>🚩</span>}
                                                        </div>
                                                    ))
                                                ))
                                            ) : (
                                                // Initial empty grid before first render
                                                Array(totalHeight * totalHeight).fill(0).map((_, i) => (
                                                    <div
                                                        key={`init-${i}`}
                                                        style={{
                                                            aspectRatio: '1/1',
                                                            backgroundColor: '#ccc',
                                                            border: '2px outset #eee'
                                                        }}
                                                    />
                                                ))
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
